import {XwaysHoarder2} from "../XwaysHoarder2";
import {gsap} from "gsap";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";

export class OutroLightSystem extends PIXI.Container {

    private _inactiveLevelsList: PIXI.Sprite;
    private _activeLvlNoCont: PIXI.Container;
    private _lightBoxContainer: PIXI.Container;
    private _lightProgressionArray: number[];
    public skipped: boolean = false;

    constructor() {
        super();
        this.init();
    }

    public startSytem(): gsap.core.Timeline {
        const roundStartValue = XwaysHoarder2.model.data.nextTopBarProgression.reduce((a, b) => a + b, 0);

        this.showLightsValue(roundStartValue);
        const startTl: gsap.core.Timeline = gsap.timeline();
        this.position.set(-70, -250);
        this.scale.set(1.2, 1.2);
        startTl.add(() => {
            this._inactiveLevelsList.visible = true;
            this.toggleVisibility(this._lightBoxContainer, true);
            this._lightBoxContainer.children.forEach((oneBox) => {
                this.toggleVisibility((<PIXI.Sprite>oneBox), true);
            });
        }, 0);


        startTl.to([this._inactiveLevelsList], {duration: 0.5, alpha: 1});
        this._lightBoxContainer.children.forEach((box) => {
            startTl.to((<PIXI.Sprite>box), {duration: 0.5, alpha: 1}, "<");
        });

        let progressLightSoundPlayed: boolean = false;
        this._lightProgressionArray.forEach((oneBoxValue: number, index: number) => {
            let oneBox: PIXI.Sprite = <PIXI.Sprite>this._lightBoxContainer.children[index];
            if (oneBoxValue > 0) {
                oneBox.children.forEach((lightOn: PIXI.DisplayObject, lightNo: number) => {
                    if (lightNo < oneBoxValue) {
                        startTl.add(this.lightProgress(<PIXI.Sprite>lightOn));
                        startTl.add(() => {

                            if(this.skipped) {
                                if(!progressLightSoundPlayed) {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_PROGRESS_LIGHT);
                                    progressLightSoundPlayed = true;
                                }
                            }
                            else {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_PROGRESS_LIGHT);
                            }
                        }, "<");
                    }
                    startTl.to(this, {duration: 0.05});
                });
                if (oneBoxValue == 3) {
                    const currentLevelImage: PIXI.Sprite = <PIXI.Sprite>this._activeLvlNoCont.children[index];
                    currentLevelImage.visible = true;
                    startTl.to(currentLevelImage, {duration: 0.05, alpha: 1});
                    startTl.add(() => {
                        XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_PROGRESS_LIGHT_LEVEL);
                    }, "<");

                }
            }

        });
        startTl.to(this, {duration: 0.3});
        startTl.to(this.position, {x: 180, y: 245, duration: 0.5});
        startTl.to(this.scale, {x: 0.5, y: 0.5, duration: 0.5}, "<");
        startTl.add(() => {
            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.OUTRO_PROGRESS_MOVE_DOWN);
        }, "<");
        startTl.timeScale(1.2);
        return startTl;
    }


    public endSystem(): gsap.core.Timeline {
        const endTl: gsap.core.Timeline = gsap.timeline();
        endTl.add(() => {
            this.toggleVisibility(this._lightBoxContainer, false);
            this._lightBoxContainer.children.forEach((oneBox) => {
                this.toggleVisibility((<PIXI.Sprite>oneBox), false);
                oneBox.alpha = 0;
                (<PIXI.Container>oneBox).children.forEach((light: PIXI.DisplayObject) => {
                    light.alpha = 0;
                })

            });
            this._activeLvlNoCont.children.forEach((item) => {
                item.visible = false;
                item.alpha = 0;
            });
        })


        return endTl;
    }

    private init() {

        this._inactiveLevelsList = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures("inActive_levels")[0]);
        this._inactiveLevelsList.name = "inactive level list";
        this._inactiveLevelsList.visible = false;
        this._inactiveLevelsList.anchor.set(0.5);
        this._inactiveLevelsList.position.set(360, 450);
        this._inactiveLevelsList.alpha = 0;
        this.addChild(this._inactiveLevelsList);

        this._activeLvlNoCont = new PIXI.Container();
        this._activeLvlNoCont.position.set(66, 0);
        this._activeLvlNoCont.name = "active level contsiner";
        for (let levelno: number = 0; levelno < 4; levelno++) {
            let img: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(`Level_${levelno}`)[0]);
            img.visible = false;
            img.alpha = 0;
            img.name = `level_${levelno}_image`;
            img.anchor.set(0.5);
            img.position.set(115 + levelno * 125, 467);
            if (levelno == 3) {
                img.position.x -= 3;
            }
            this._activeLvlNoCont.addChild(img);
        }
        this.addChild(this._activeLvlNoCont);

        this._lightBoxContainer = new PIXI.Container();
        this._lightBoxContainer.name = "LightBoxContainer";
        for (let levlno: number = 0; levlno < 4; levlno++) {
            const lightBox: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures("lightBox")[0]);
            lightBox.name = `lightbox_level${levlno}`;
            lightBox.visible = false;
            lightBox.alpha = 0;
            lightBox.anchor.set(0.5);
            lightBox.scale.set(0.7, 0.7);
            lightBox.position.set(120 + levlno * 122, 410);
            if (levlno == 2 || levlno == 3) {
                lightBox.position.x += 6;
            }
            for (let lightCount: number = 0; lightCount < 3; lightCount++) {
                const lightOn: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(levlno === 3 && lightCount === 2 ? "pinkLightON" : "lightON")[0]);
                lightOn.visible = false;
                lightOn.alpha = 0;
                lightOn.anchor.set(0.5);
                lightCount === 0 ? lightOn.position.set(-56, -11) : lightCount === 1 ? lightOn.position.set(-11, -17) : lightOn.position.set(36, -16);
                lightBox.addChild(lightOn)
            }
            this._lightBoxContainer.position.set(68, -15);
            this._lightBoxContainer.addChild(lightBox);
        }
        this.addChild(this._lightBoxContainer);

    }

    private lightProgress(obj: PIXI.Sprite): gsap.core.Timeline {
        const lightTl: gsap.core.Timeline = gsap.timeline();
        lightTl.to(obj, {duration: 0.05, alpha: 1});
        return lightTl;
    }

    private showLightsValue(value: number) {
        this._lightProgressionArray = [0, 0, 0, 0, 0];
        if (value <= 3) {
            this._lightProgressionArray[0] = value;
        } else if (value > 3 && value <= 6) {
            this._lightProgressionArray[0] = 3;
            this._lightProgressionArray[1] = value - 3;
        } else if (value > 6 && value <= 9) {
            this._lightProgressionArray[0] = 3;
            this._lightProgressionArray[1] = 3;
            this._lightProgressionArray[2] = value - 6;
        } else if (value > 9 && value < 12) {
            this._lightProgressionArray[0] = 3;
            this._lightProgressionArray[1] = 3;
            this._lightProgressionArray[2] = 3;
            this._lightProgressionArray[3] = value - 9;
        } else {
            this._lightProgressionArray[0] = 3;
            this._lightProgressionArray[1] = 3;
            this._lightProgressionArray[2] = 3;
            this._lightProgressionArray[3] = 3;
        }
    }


    private toggleVisibility(parentContainer: PIXI.Container | PIXI.Sprite, toShow: boolean): void {
        parentContainer.children.forEach((item) => {
            item.visible = toShow;
        })
    }
}